import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { Modal, ModalDialog as Dialog } from '@micromag/core/components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ThemeDuplicateForm from '../forms/ThemeDuplicate';

const propTypes = {
    theme: MicromagPropTypes.story.isRequired,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    onConfirm: null,
    onCancel: null,
    className: null,
};

const ThemeDuplicateModal = ({ theme, onConfirm, onCancel, className }) => (
    <Modal>
        <Dialog
            title={<FormattedMessage defaultMessage="Duplicate theme" description="Modal title" />}
            className={classNames([
                {
                    [className]: className,
                },
            ])}
            onClose={onCancel}
        >
            <ThemeDuplicateForm theme={theme} onComplete={onConfirm} onCancel={onCancel} />
        </Dialog>
    </Modal>
);

ThemeDuplicateModal.propTypes = propTypes;
ThemeDuplicateModal.defaultProps = defaultProps;

export default ThemeDuplicateModal;
